import { render, staticRenderFns } from "./MembersWithBelt.vue?vue&type=template&id=74593118&"
import script from "./MembersWithBelt.vue?vue&type=script&lang=js&"
export * from "./MembersWithBelt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports